import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as BankTransferIntoIcon } from '../../../../assets/icons/svg/large-icons/ic-large-bank.svg';
import Heading from '../../../../generic-components/Heading';
import Button from '../../../../generic-components/Button';
import { STYLES } from './BankTransferIntro.styles';

interface IProps {
  onSubmit: () => void;
}

export const BankTransferIntro = ({ onSubmit }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={STYLES.CONTAINER}>
      <div className={STYLES.MAIN_TITLE_WRAPPER}>
        <Heading testId='enrollTitle' title={t('ACH_OUT_ENROLL.MAIN_TITLE')} className={STYLES.MAIN_TITLE} />
      </div>
      <div className={STYLES.CONTENT_BODY}>
        <BankTransferIntoIcon />
        <Heading testId='enrollTitle' title={t('ACH_OUT_ENROLL.TITLE')} className={STYLES.TITLE} />
        <Heading testId='enrollText' title={t('ACH_OUT_ENROLL.TEXT')} className={STYLES.TEXT} />
        <Button onClick={onSubmit} className={STYLES.SUBMIT_CTA} title={t('ACH_OUT_ENROLL.SUBMIT_CTA')} id='bankTransferCTA' />
      </div>
    </div>
  );
};
